module.exports = __webpack_public_path__ + "static/media/business.4e4dc2da.webp";